/**
 * Created by Yaroslav S. on 10/07/2024
 * Copyright © 2020 Curriculum Ltd. All rights reserved.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApplicationHttpClient } from 'src/app/shared/api/application-http-client';
import { ITagSearchResponse } from './question-tags-selector.interface';

@Injectable()
export class QuestionTagsSelectorService {

  constructor(private httpClient: ApplicationHttpClient){}

  getQuestionTags(curriculumId: number, searchText: string = '', page: number = 0, size: number = 20): Observable<ITagSearchResponse> {
    const query = encodeURIComponent(searchText || '');
    return this.httpClient.get<ITagSearchResponse>(`/tag/search?text=${query}&curriculumId=${curriculumId}&page=${page}&size=${size}`);
  }
}
